import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
    const [navbarAnimation, setNavbarAnimation] = useState(false);

    const changeBackground = () => {
        if(window.scrollY >= 80) {
            setNavbarAnimation(true);
        }
        else{
            setNavbarAnimation(false);
        }
    }
    window.addEventListener('scroll', changeBackground);

    return (
        <nav className={navbarAnimation ? "navbar navbar-expand-lg navbar-light mb-5 sticky-lg-top nav-bg" : "navbar navbar-expand-lg navbar-light mb-5"}>
            <div className="container">
                <Link to="#" className="navbar-brand text-white fw-bold text-uppercase">Shahnewaz</Link>
                <button className="navbar-toggler cursor-pointer" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <NavLink className="nav-link" exact activeClassName="nav-link-active" to="/">Home</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/projects"  activeClassName="nav-link-active" className="nav-link border-item">Projects</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/blogs"  activeClassName="nav-link-active" className="nav-link border-item">Blogs</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink to="/about" exact activeClassName="nav-link-active" className="nav-link border-item">About</NavLink>
                        </li>
                        <li className="nav-item nav-contact">
                            <NavLink to="/contact" exact activeClassName="nav-link-active" className="nav-link border-item me-1">Contact</NavLink>
                        </li>
                        <a href="https://drive.google.com/uc?id=1ATfuxvT81EqUQqjkU-6mmmwqJUKdpzRg&export=download" className="nav-link btn btn-custom px-3 fw-bold text-white" target="_blank" rel="noreferrer">Resume</a>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;